<template>
    <v-row align="end" align-md="center">
        <v-col cols="12" md="auto">
            <company-view-heading-logo v-bind="{ company }" min-width="160" />
        </v-col>
        <v-col cols="12" md="auto">
            <template v-if="isLinkEnabled">
                <router-link v-bind="{ to }" tag="a" class="tit font-weight-bold"> {{ company?.name }}</router-link>
            </template>
            <template v-else>
                <h3 class="tit">{{ company?.name }}</h3>
            </template>
        </v-col>
        <v-col cols="auto" v-if="href">
            <v-btn text v-bind="{ href }" target="_blank" color="primary" class="ma-n8"> 홈페이지 바로가기 <i class="icon icon-right-arrow-sm ml-4 ml-lg-8"></i> </v-btn>
        </v-col>
        <v-spacer />
        <v-col cols="auto">
            <slot name="actions" />
        </v-col>
    </v-row>
</template>

<script>
import CompanyViewHeadingLogo from "./company-view-heading-logo.vue";

export default {
    components: {
        CompanyViewHeadingLogo,
    },
    props: {
        company: { type: Object, default: () => ({}) },
        isLinkEnabled: { type: Boolean, default: false },
    },
    computed: {
        to() {
            let to = "/companies";

            const { _id: _company } = this.company || {};
            if (_company) to += `/${_company}`;

            return to;
        },
        href() {
            let url = this.company?.website?.trim?.() || "";
            if (!url) return;
            if (!/https?:\/\//.test(url)) url = "http://" + url;
            return url;
        },
    },
};
</script>

<style lang="scss" scoped>
</style>